import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ReduxStoreRoot } from "../types";
import { clearPOSAlerts } from "../state/root";
import { History } from "history";

const useClearAlertsOnPathChange = (history: History): void => {
  const dispatch = useDispatch();
  const { alerts } = useSelector(
    (state: ReduxStoreRoot) => state.posConfigTool.alerts
  );
  useEffect(() => {
    const currentPath = history.location.pathname;

    const unlisten = history.listen((location) => {
      const pathChanged = currentPath !== location.pathname;
      if (pathChanged && alerts.length) {
        dispatch(clearPOSAlerts());
      }
    });

    return () => {
      unlisten();
    };
  }, [alerts.length, dispatch, history]);
};

export default useClearAlertsOnPathChange;
